var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCompress = function SvgCompress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.769 12.231 66.935 33.065m0 0H87.77m-20.834 0V12.23m-54.639.065 10.417 10.417L33.13 33.13m0 0V12.296m0 20.834H12.296m75.108 54.274L66.571 66.571m0 0v20.833m0-20.833h20.833M12.635 87.365 33.47 66.53m0 0H12.635m20.834 0v20.834",
    stroke: "currentColor",
    strokeWidth: 8.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgCompress;